export default function () {
  return {
    username: '',
    password: '',
    error: '',
  }
}
